import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from '@buyiq-core/models/app-settings';
import { DataResource } from '@buyiq-custom-types';
import { Observable } from 'rxjs';
import { ProductOrderHistoryList } from '../models/order-history';

@Injectable({
    providedIn: 'root'
})
export class OrderHistoryProductResource implements DataResource<ProductOrderHistoryList> {
    private readonly baseUrl: string;

    constructor(private http: HttpClient, private appSettings: AppSettings) {
        this.baseUrl = `${this.appSettings.apis.order}`;
    }

    getAll(chainStoreId: number): Observable<Array<ProductOrderHistoryList>> {
        const url = `${this.baseUrl}/products/history`;

        const params = new HttpParams({
            fromObject: {
                chainStoreId: (chainStoreId || 0).toString(),
            }
        });
        return this.http.get<Array<ProductOrderHistoryList>>(url, { params });
    }
}
